import * as angular from "angular";
import {IController} from "angular";
import {WebhooksRequests} from "../../services/webhooks-requests.service";

export class webhooksTopicsMultiSelectCtrl implements IController {

  topics: any;
  options: any;
  showIcon: any;
  isRequired: any;
  onChange: Function;

  /* @ngInject */
  constructor(private webhooksRequests: WebhooksRequests, private $log, private $mdSelect) {
  }

  $onInit() {
    if (!this.topics) {
      this.topics = [];
    }
    if (!this.options) {
      this._getTopics();
    }
  };

  doneHideSelect() {
    this.$mdSelect.hide();
  }

  resetHideSelect() {
    this.$mdSelect.hide();
    this.topics = [];
    this.onChange({topics: []});
  }

  _getTopics() {
    this.webhooksRequests.getTopics()
      .then((topics) => {
        this.options = topics;
      })
      .catch((error) => {
        this.$log.error('Failed to get Topics', error);
      })
  }
}

angular
  .module('bringoz.admin.webhooks')
  .component('webhooksTopicsMultiSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      topics: '<',
      options: '<',
      showIcon: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./webhooks-topics-multi-select.html').default,
    controller: webhooksTopicsMultiSelectCtrl
  });
